import { Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';

// Services
import { CookieService } from 'ngx-cookie-service';

// Configs
import { COOKIE_ENUMERATION, LOAN_APPLICATION_STATE_ENUMERATION } from '@home/login/configs';
import { ROUTES_CONSTANTS } from '@shared/configs';

// Types
import { LoanRedirectOptionsType, RedirectionHandlerType } from '../models';

// Environment
import { environment } from '@environments/environment';

export class RPRedirectionHandler implements RedirectionHandlerType {
  private readonly cookieService: CookieService;
  private readonly ngZone: NgZone;
  private readonly router: Router;

  private readonly routeMap: {
    PENDING_SIGNATURE: string;
    PENDING_METHOD_DISPERSION: string;
    PENDING_FINISH: string;
  };

  constructor(private readonly injector: Injector) {
    this.cookieService = this.injector.get(CookieService);
    this.ngZone = this.injector.get(NgZone);
    this.router = this.injector.get(Router);

    this.routeMap = {
      PENDING_SIGNATURE: ROUTES_CONSTANTS.SIGN_APPLICATION,
      PENDING_METHOD_DISPERSION: ROUTES_CONSTANTS.DISPERSION_METHOD,
      PENDING_FINISH: ROUTES_CONSTANTS.PRODUCT_VALIDATIONS,
    };
  }

  public canHandle(): boolean {
    return true;
  }

  public handle({ loanState }: LoanRedirectOptionsType): void {
    if (loanState === LOAN_APPLICATION_STATE_ENUMERATION.PENDING_FINISH) {
      this.setCookiesAndStorage(COOKIE_ENUMERATION.IS_NEW_LOAN, 'true');
    }
    const route = (loanState && this.routeMap[loanState]) || ROUTES_CONSTANTS.NEW_LOAN;
    this.navigateToRoute(route);
  }

  private navigateToRoute(route: string): void {
    this.ngZone.run(() => {
      this.router.navigate([route]);
    });
  }

  private setCookiesAndStorage(key: string, value: number | string | Date): void {
    this.cookieService.set(key, value.toString(), 1, '/', environment.domain);
    sessionStorage.setItem(key, value.toString());
  }
}
